import { render, staticRenderFns } from "./NoteReminders.vue?vue&type=template&id=95c99d82&scoped=true"
import script from "./NoteReminders.vue?vue&type=script&lang=ts"
export * from "./NoteReminders.vue?vue&type=script&lang=ts"
import style0 from "./NoteReminders.vue?vue&type=style&index=0&id=95c99d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c99d82",
  null
  
)

export default component.exports